import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class LoaderService {
  

  private isLoading: Subject<boolean> = new Subject<boolean>()

  public isLoading$: Observable<boolean> = this.isLoading.asObservable();


  constructor() { }

  
  startLoading():void{
    this.isLoading.next(true);
  }
  stopLoading():void{
    this.isLoading.next(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/helper/core/loader/loader.service.ts